export const QUICK_ACTIONS_PATH = 'v1/quick-actions';
export const CARE_PROVIDERS_PATH = 'v1/care-providers';
export const PLATFORM = 'web';
